import AWS from "aws-sdk";
import {
  baseURL,
  aws_access_key_id,
  aws_secret_access_key,
  bucketName,
  hostname,
  folderStructurePath,
} from "./config";
import axios from "axios";
import { useDispatch } from "react-redux";
import { UPLOAD_FILE_AWS } from "../Component/store/dialogue/dialogue.type";

export const uploadFile = async (
  FileName,
  folderStructure,
  dispatch,
  loaderType
) => {
  try {
    const formData = new FormData();
    formData.append(
      "folderStructure",
      folderStructurePath + "/" + folderStructure
    );
    formData.append("keyName", FileName?.name);
    formData.append("content", FileName);
    const response = await axios.post(`admin/file/upload-file`, formData, {
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        dispatch &&
          dispatch({
            type: UPLOAD_FILE_AWS,
            payload: {
              uploadFilePercent: percentCompleted,
              loaderType: loaderType,
            },
          });
      },
    });
    const resDataUrl = response.data.url;
    const spaceEndpoint = new AWS.Endpoint(`${hostname}`);

    const fileName =
      folderStructurePath + "/" + folderStructure + "/" + FileName?.name;
    const s3 = new AWS.S3({
      endpoint: spaceEndpoint,
      accessKeyId: aws_access_key_id,
      secretAccessKey: aws_secret_access_key,
    });

    const params = {
      Bucket: bucketName,
      Key: fileName,
      Expires: 60,
    };

    const imageURL = await new Promise((resolve, reject) => {
      s3.getSignedUrl("getObject", params, (err, url) => {
        if (err) {
          console.error("Error generating presigned URL:", err);
          reject(err);
          return;
        }
        resolve(url);
      });
    });

    return { resDataUrl, imageURL };
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const resolveImageUrl = (source) => {
  if (typeof source !== "string") return "";

  const trimmed = source.trim();
  if (!trimmed) return "";

  try {
    const parsedUrl = new URL(trimmed);
    if (parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:") {
      return trimmed;
    }
  } catch (error) {
    // Ignore parsing errors for plain object keys.
  }

  const normalized = trimmed.split("?")[0].replace(/^\/+/, "");
  if (/^https?:\/\//i.test(normalized)) {
    return normalized;
  }

  if (/^(storage|uploads)\//i.test(normalized)) {
    return `${baseURL.replace(/\/+$/, "")}/${trimmed.replace(/^\/+/, "")}`;
  }

  return trimmed;
};

export const covertURl = async (FileName) => {
  try {
    const spaceEndpoint = new AWS.Endpoint(`${hostname}`);

    const s3 = new AWS.S3({
      endpoint: spaceEndpoint,
      accessKeyId: aws_access_key_id,
      secretAccessKey: aws_secret_access_key,
    });

    let normalizedFileName = (FileName || "").trim();

    if (!normalizedFileName) {
      return { FileName, imageURL: "" };
    }

    const directUrl = resolveImageUrl(normalizedFileName);
    if (/^https?:\/\//i.test(directUrl)) {
      return { FileName, imageURL: directUrl };
    }

    try {
      const parsedUrl = new URL(normalizedFileName);
      normalizedFileName = parsedUrl.pathname || normalizedFileName;
    } catch (error) {
      // Ignore parsing errors for plain object keys.
    }

    normalizedFileName = normalizedFileName.split("?")[0].replace(/^\/+/, "");

    try {
      normalizedFileName = decodeURIComponent(normalizedFileName);
    } catch (error) {
      // Keep original key if decoding fails.
    }

    if (normalizedFileName.startsWith(`${bucketName}/`)) {
      normalizedFileName = normalizedFileName.slice(bucketName.length + 1);
    }

    const isQualifiedKey =
      normalizedFileName.startsWith("main/") ||
      normalizedFileName.startsWith(`${folderStructurePath}/`);
    const resolvedKey = isQualifiedKey
      ? normalizedFileName
      : `${folderStructurePath}/${normalizedFileName}`;

    const params = {
      Bucket: bucketName,
      Key: resolvedKey,
      Expires: 100,
    };

    const imageURL = await new Promise((resolve, reject) => {
      s3.getSignedUrl("getObject", params, (err, url) => {
        if (err) {
          console.error("Error generating presigned URL:", err);
          reject(err);
          return;
        }
        resolve(url);
      });
    });

    return { FileName, imageURL };
  } catch (error) {
    console.error(error);
    throw error;
  }
};
